/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { Fragment, type PropsWithChildren } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports
import { jsx } from '@emotion/react';

import type { InviteToEditComponentProps } from '@atlaskit/editor-common/collab';
import { ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import AddIcon from '@atlaskit/icon/core/add';

import { inviteTeamWrapperStyles } from './styles';

const ID = (props: PropsWithChildren<Object>) => <Fragment>{props.children}</Fragment>;

type InviteToEditButtonProps = PropsWithChildren<{
	Component?: React.ComponentType<React.PropsWithChildren<InviteToEditComponentProps>>;
	onClick?: React.MouseEventHandler;
	selected?: boolean;
	title: string;
}>;

export const InviteToEditButton = (props: InviteToEditButtonProps): jsx.JSX.Element | null => {
	const { Component, onClick, selected, title } = props;

	const iconBefore = React.useMemo(() => <AddIcon label={title} />, [title]);

	if (!Component && !onClick) {
		return null;
	}

	const Wrapper = Component ? Component : ID;

	return (
		// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		<div css={inviteTeamWrapperStyles}>
			<Wrapper>
				<ToolbarButton
					// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
					className="invite-to-edit"
					onClick={onClick}
					selected={selected}
					title={title}
					titlePosition="bottom"
					iconBefore={iconBefore}
				/>
			</Wrapper>
		</div>
	);
};
